function initEnviameTracker() {
  // Asegura que exista el contenedor antes de seguir
  var trackerContainer = document.getElementById('enviame-tracker');
  if (!trackerContainer) return;

  // Placeholder desde atributo del contenedor
  window.enviameTrackerModal = document.createElement('div');
  if (trackerContainer.getAttribute('text-placeholder') != null) {
    window.placeholderValue = trackerContainer.getAttribute('text-placeholder');
  } else {
    window.placeholderValue = "";
  }

  // Guarda la key de Envíame desde data-key del contenedor
  window.enviameTrackerKey = trackerContainer.getAttribute('data-key');

  // Cerrar modal (force ignora posición del mouse)
  window.closeEnviameTracker = function(force) {
    if (!window.onEnviameTrackerModal || force) {
      var modalEl = document.getElementById('enviame-tracker-modal');
      if (modalEl) modalEl.style.display = 'none';
    }
  };

  // Crear y abrir modal al usar el botón del widget
  window.openEnviameTracker = function(id) {
    console.log('veo', window.enviameTrackerKey, id);

    // Modal flotante con iframe
    window.enviameTrackerContent = `
      <div id="enviame-modal" style="
      position: fixed;
      top:0;
      left:0;
      background: #00000099;
      z-index: 90909091;
      height: 100%;
      width: 100%">
        <div id="enviame-modal-interior" style="
        background: white;
        border-radius: 10px;
        width:70%;
        margin:auto;
        margin-top: 50px;
        max-height: 700px;
        position: relative;
        text-align: center;
        height: 80%">
          <button onclick="window.closeEnviameTracker(true)" style="
            border-radius: 100%;
            background: red;
            border:none;
            color:white;
            padding:6px 10px;
            position: absolute;
            right: -10px;
            top: -10px;
            cursor: pointer;
            z-index: 90909092;
          ">X</button>
          <img src="https://storage.googleapis.com/san-francisco-ms.appspot.com/loading.svg" id="enviameLoader">
          <iframe style="
              width:100%;
              height:100%;
              border-radius: 10px;
              border:none"
              src="https://api.enviame.io/s2/companies/${window.enviameTrackerKey}/deliveries/${encodeURIComponent(id)}/tracking"></iframe>
        </div>
      </div>
    `;
    window.enviameTrackerModal.remove();
    window.enviameTrackerModal = document.createElement('div');
    window.enviameTrackerModal.id = 'enviame-tracker-modal';
    window.enviameTrackerModal.insertAdjacentHTML('beforeend', window.enviameTrackerContent);
    document.body.append(window.enviameTrackerModal);
    document.getElementById('enviame-modal').onmousedown = function() { window.closeEnviameTracker(); };
    document.getElementById('enviame-modal-interior').onmouseenter = function() { window.onEnviameTrackerModal = true; };
    document.getElementById('enviame-modal-interior').onmouseleave = function() { window.onEnviameTrackerModal = false; };
  };

  // HTML del widget a insertar (si aún no existe)
  var widgetContent = `
    <style>
      #enviame-modal iframe {
        background: ;
      }
      #enviame-modal-interior {
        position: relative;
      }
      #enviame-modal-interior iframe {
        position: absolute;
        top:0;
        left:0;
        z-index: 90909090;
      }
      #enviameLoader {
        position: absolute;
        left: calc(50% - 70px);
        top:240px;
        z-index: 90909089;
        width: 133px;
      }
      #enviameTrackerInput, #enviameTrackerInput:focus {
        border: 2px solid #2a83f9;
        padding: 5px;
        outline: none;
      }
      #enviameTrackerSubmit {
        border: 2px solid #2a83f9;
        padding: 5px;
        background: #2a83f9;
        color: white;
        cursor: pointer;
      }
      #enviameTrackerSubmit:hover {
        background: #67a6ff;
        border: 2px solid #67a6ff;
      }
      #enviameTrackerSubmit:active {
        background: #056af1;
        border: 2px solid #056af1;
        outline: none;
      }
    </style>
    <input type="text" id="enviameTrackerInput" placeholder="${window.placeholderValue}">
    <button id="enviameTrackerSubmit" onclick="window.openEnviameTracker(enviameTrackerInput.value)">Ver estado</button>
    <img style="width:1px;height:1px;visibility:hidden;position:absolute" src="https://storage.googleapis.com/san-francisco-ms.appspot.com/loading.svg">
  `;

  // Inserta solo si no existen ya los elementos (evita duplicados)
  if (!document.getElementById('enviameTrackerInput') || !document.getElementById('enviameTrackerSubmit')) {
    trackerContainer.insertAdjacentHTML('beforeend', widgetContent);
  }
}

// === IMPORTANTE: inicializa apenas el DOM esté listo (no espera imágenes/iframes) ===
if (document.readyState === 'loading') {
  // El DOM todavía se está parseando: espera DOMContentLoaded
  document.addEventListener('DOMContentLoaded', initEnviameTracker);
} else {
  // Script con defer o DOM ya listo: inicializa altiro
  initEnviameTracker();
}
